export default __webpack_public_path__ + "static/media/Monica.f6a80d15.png";